module.exports = __webpack_public_path__ + "static/media/nodejs.a40691d5.png";